import type { Notification } from '@hooks/notifications';

export const BADGE_MAX = 99;

export const NOTIFICATIONS_PAGE_SIZE = 20;

export type NotificationsTab = 'all' | 'unread';

export type RelativeTime = {
  unit: Intl.RelativeTimeFormatUnit;
  value: number;
};

const RELATIVE_TIME_STEPS: Array<{
  limit: number;
  seconds: number;
  unit: Intl.RelativeTimeFormatUnit;
}> = [
  { limit: 60, seconds: 1, unit: 'second' },
  { limit: 3600, seconds: 60, unit: 'minute' },
  { limit: 86400, seconds: 3600, unit: 'hour' },
  { limit: 604800, seconds: 86400, unit: 'day' },
  { limit: 2629800, seconds: 604800, unit: 'week' },
  { limit: 31557600, seconds: 2629800, unit: 'month' },
  { limit: Infinity, seconds: 31557600, unit: 'year' },
];

export const getRelativeTime = (date: string | undefined, now: number): RelativeTime | null => {
  if (!date) return null;
  const timestamp = Date.parse(date);
  if (Number.isNaN(timestamp)) return null;

  const elapsed = Math.max(0, Math.floor((now - timestamp) / 1000));
  const step = RELATIVE_TIME_STEPS.find(({ limit }) => elapsed < limit) ?? RELATIVE_TIME_STEPS[0];
  if (step.unit === 'second') return { unit: 'second', value: 0 };

  return { unit: step.unit, value: -Math.floor(elapsed / step.seconds) };
};

export const getNotificationResourcePath = ({
  resourceId,
  resourceType,
}: Pick<Notification, 'resourceId' | 'resourceType'>): string | null => {
  if (resourceId === null || resourceId === undefined) return null;
  if (resourceType === 'generic_order') return `/reservations/${resourceId}`;
  if (resourceType === 'account') return `/crm/accounts/${resourceId}/edit`;
  return null;
};

export const isUnread = ({ readAt }: Pick<Notification, 'readAt'>): boolean => !readAt;
